import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Login from '../views/Login.vue'
import Signup from '../views/Signup.vue'
import AccountView from '../views/AccountView.vue'
import AccountEdit from '../views/AccountEdit'
import Recipes from '../views/Recipes.vue'
import RecipeAdd from '../views/RecipeAdd.vue'
import RecipeView from '../views/RecipeView.vue'
import RecipeEdit from '../views/RecipeEdit.vue'
import Resources from '../views/Resources.vue'
import ResourceAdd from '../views/ResourceAdd.vue'
import ResourceView from '../views/ResourceView.vue'
import ResourceEdit from '../views/ResourceEdit.vue'
import Organizations from '../views/Organizations.vue'
import OrganizationAdd from '../views/OrganizationAdd.vue'
import OrganizationView from '../views/OrganizationView.vue'
import OrganizationEdit from '../views/OrganizationEdit.vue'
import Groups from '../views/Groups.vue'
import GroupAdd from '../views/GroupAdd.vue'
import GroupView from '../views/GroupView.vue'
import GroupEdit from '../views/GroupEdit.vue'
import PageNotFound from '../views/PageNotFound.vue'
import WhatWeOffer from '../views/WhatWeOffer'
import AboutUs from '../views/AboutUs'
import ForgotPassword from '../views/ForgotPassword'
import PasswordReset from '../views/PasswordReset'
import ConfirmUser from '../views/ConfirmUser'
import OurUsers from '../views/OurUsers'
import Bookmarks from '../views/Bookmarks'

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/forgot-password',
      name: 'forgotPassword',
      component: ForgotPassword
    },
    {
      path: '/user/confirm',
      name: 'confirmUser',
      component: ConfirmUser
    },
    {
      path: '/user/resetPassword',
      name: 'passwordReseted',
      component: PasswordReset
    },
    {
      path: '/signup',
      name: 'signup',
      component: Signup
    },
    {
      path: '/workspace/account',
      name: 'account',
      component: AccountView
    },
    {
      path: '/workspace/account/edit',
      name: 'accountEdit',
      component: AccountEdit
    },
    {
      path: '/workspace/what-we-offer',
      name: 'whatWeOffer',
      component: WhatWeOffer
    },
    {
      path: '/workspace/our-users',
      name: 'OurUsers',
      component: OurUsers
    },
    {
      path: '/workspace/about-us',
      name: 'aboutUs',
      component: AboutUs
    },
    {
      path: '/workspace/recipes',
      name: 'recipes',
      component: Recipes
    },
    {
      path: '/workspace/bookmarks',
      name: 'bookmarks',
      component: Bookmarks
    },
    {
      path: '/workspace/recipes/add',
      name: 'recipeAdd',
      component: RecipeAdd
    },
    {
      path: '/workspace/recipes/:id',
      name: 'recipeView',
      component: RecipeView,
      props: true
    },
    {
      path: '/workspace/recipes/:id/edit',
      name: 'recipeEdit',
      component: RecipeEdit
    },
    {
      path: '/workspace/resources',
      name: 'resources',
      component: Resources
    },
    {
      path: '/workspace/resources/add',
      name: 'resourceAdd',
      component: ResourceAdd
    },
    {
      path: '/workspace/resources/:id',
      name: 'resourceView',
      component: ResourceView
    },
    {
      path: '/workspace/resources/:id/edit',
      name: 'resourceEdit',
      component: ResourceEdit
    },
    {
      path: '/workspace/organizations',
      name: 'organizations',
      component: Organizations
    },
    {
      path: '/workspace/organizations/add',
      name: 'organizationAdd',
      component: OrganizationAdd
    },
    {
      path: '/workspace/organizations/:id',
      name: 'organizationView',
      component: OrganizationView
    },
    {
      path: '/workspace/organizations/:id/edit',
      name: 'organizationEdit',
      component: OrganizationEdit
    },
    {
      path: '/workspace/groups',
      name: 'groups',
      component: Groups
    },
    {
      path: '/workspace/groups/add',
      name: 'groupAdd',
      component: GroupAdd
    },
    {
      path: '/workspace/groups/:id',
      name: 'groupView',
      component: GroupView
    },
    {
      path: '/workspace/groups/:id/edit',
      name: 'groupEdit',
      component: GroupEdit
    },
    {
      path: '*',
      name: '404',
      component: PageNotFound
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})

// router.beforeEach((to, from, next) => {
//   let username = JSON.parse(window.localStorage.getItem('username'))
//   let isAuthenticated = username !== null
//   if (isAuthenticated) {
//     if (to.name === 'login' || to.name === 'home' || to.name === 'signup'){
//       next()
//     } else {
//     //  next('/login')
//     }
//   }
// })

export default router



// WEBPACK FOOTER //
// ./src/router/index.js